<template>
  <!-- <div class="grid grid-cols-2 gap-6 mt-6"> -->
  <div class="grid grid-cols-12 gap-6">
    <div v-if="!isBusy" class="col-span-12">
      <div class="box">
        <div class="pt-5 pl-5 pr-1">
          <div class="grid grid-cols-12 gap-x-5">
            <div class="col-span-12 pt-5 pb-2 px-2">
              <h4 class="font-medium text-theme-3 text-base mb-5">
                Audit Logs
              </h4>
              <div
                v-if="logsSummary.length"
                class="flex px-1 py-2 log-summary bg-gray-200"
              >
                {{ logsSummary }}
              </div>
              <div v-else class="flex row justify-left  items-center">
                <AlertCircleIcon size="16" />
                <span class="pl-2">No Logs available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FetchingRecordDivTemplate v-else marginTop="0" />
  </div>
</template>

<script>
import FetchingRecordDivTemplate from "@/components/fetching-record-div-template/Main";
import { AuditLogs } from "@/composables/components/loan-applications/audit-logs";

export default {
  components: {
    FetchingRecordDivTemplate
  },
  props: {
    applicationId: {
      type: Number,
      require: false
    }
  },
  setup(props) {
    const { logsSummary, auditLogsFetching } = AuditLogs(props);
    return {
      logsSummary,
      isBusy: auditLogsFetching
    };
  }
};
</script>

<style scoped>
.log-summary {
  max-height: 26rem;
  overflow: auto;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
}
</style>
